import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

export interface UserSessionResponse {
  status: 'success' | 'error';
  logged_in: boolean;
  user_id?: number | string;
  username?: string;
  email?: string;
  csrf_token?: string;
}

@Injectable({ providedIn: 'root' })
export class SessionService {
  private readonly sessionApiUrl = `${environment.serverAuthUrl}api/session`;
  private csrfToken: string | null = null;

  constructor(private http: HttpClient) {}

  setCsrfToken(token: string | null | undefined): void {
    this.csrfToken = token || null;
  }

  getCsrfToken(): string | null {
    return this.csrfToken;
  }

  clear(): void {
    this.csrfToken = null;
  }

  getSession(): Observable<UserSessionResponse> {
    return this.http.get<UserSessionResponse>(this.sessionApiUrl, {
      withCredentials: true,
      headers: { 'Cache-Control': 'no-cache' },
    });
  }

  upgradeLegacySession(clientToken: string, username: string): Observable<UserSessionResponse> {
    const body = new FormData();
    body.append('client_token', clientToken);
    body.append('username', username);

    return this.http.post<UserSessionResponse>(this.sessionApiUrl, body, {
      withCredentials: true,
    });
  }

  logout(clientToken: string, username: string): Observable<unknown> {
    const body = new FormData();
    if (clientToken) body.append('client_token', clientToken);
    if (username) body.append('username', username);

    let headers = new HttpHeaders();
    if (this.csrfToken) headers = headers.set('X-CSRF-Token', this.csrfToken);

    return this.http.post(`${environment.serverAuthUrl}api/logout`, body, {
      withCredentials: true,
      headers,
    });
  }
}
